module.exports = __webpack_public_path__ + "static/media/close.03524c97.svg";